import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { SectionHeading } from '~/components/molecules/heading/SectionHeading';
import typography from '~/components/styles/typography.module.scss';
import styles from './productLayout.module.scss';

export interface IProductsProps extends PropsWithChildren {
    CategoriesComponent: JSX.Element | null;
    productsTitleRef: React.RefObject<HTMLDivElement>;
}

const ProductLayout: React.FC<IProductsProps> = ({ CategoriesComponent, children, productsTitleRef }) => {
    return (
        <div className={classNames(styles.serpProducts)}>
            {CategoriesComponent}

            <div className={styles.serpProducts}>
                <SectionHeading
                    text={{ id: 'products_title', defaultMessage: 'Produkty' }}
                    className={classNames(typography.sectionTitle)}
                    ref={productsTitleRef}
                    data-testid="products-title"
                />
                <div className={styles.serpResults}>{children}</div>
            </div>
        </div>
    );
};

export default ProductLayout;
